<template>
  <div class="confirmation-cont">
    <div class="confirmation" v-if="!getAllInfos.restoAutoAccept" style="margin-top: 32px;">
      <p>Votre réservation a été soumise au restaurateur.</p>
      <p>Une fois votre réservation validée un email de confirmation vous sera envoyé.</p>
      <p>IMPORTANT: Si vous ne recevez pas nos emails, merci de vérifier vos spams ou l'onglet Promotions sur Gmail.</p>
      <p>Bonne journée !</p>
    </div>
    <div class="confirmation" v-else-if="getAllInfos.restoAutoAccept" style="margin-top: 54px;">
      <p v-if="getAllInfos.resaConfirmMessage" v-html="renderMarkdown(getAllInfos.resaConfirmMessage)"></p>
      <p v-else>
        Bravo ! <br />Votre réservation est acceptée par le restaurateur.
      </p>
      <p>Nous vous attendons donc le <b>{{ getSelectedDateObject.labelDay }} {{ getSelectedDateObject.day }}
          {{ getSelectedDateObject.labelMonth }} {{ getSelectedDateObject.year }} à {{ getSelectedService.hour }}</b>
        pour
        <b>{{ getNbCouvert }} couvert(s).</b>
      </p>
      <p>Bonne journée !</p>
    </div>
    <!-- <el-button 
      class="booking-button"
      @click="resetForkBooking()"
    >
      Réserver à nouveau
    </el-button> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { renderMarkdown } from '../../tools/markdownHelper';

export default {
  name: 'ConfirmForkBooking',
  computed: {
    ...mapGetters({
      getAllInfos: 'infos/getAllInfos',
      getSelectedDateObject: 'forkBooking/getSelectedDateObject',
      getSelectedService: 'forkBooking/getSelectedService',
      getNbCouvert: 'forkBooking/getNbCouvert'
    })
  },
  methods: {
    ...mapActions({
      resetForkBooking: 'forkBooking/resetForkBooking'
    }),
    renderMarkdown,
  }
}
</script>

<style lang="scss">
.confirmation-cont {
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  .confirmation {

    p {
      font-size: 18px;
      font-weight: 500;

      b {
        font-weight: 800;
      }
    }
  }
}
</style>